import { StyledMightyFuSubProduct, StyledQuantity } from './style';
import { CSSProperties } from 'react';
import { IProductResponse, ProductData } from 'utils/types';
import { Box } from '@mui/material';
import { TooltipRenderer } from 'components/TooltipTemplate/TooltipRenderer';

const tooltipIcon =
  'https://media-dev.appcharge.com/media/6683d66f3ad9e626ecc051f5/1724936979813__75209c47-b991-4515-a23b-c3bd7ed7fa2a';

const tooltipButtonStyle: CSSProperties = {
  position: 'absolute',
  right: '5px',
  height: '24px',
  zIndex: 2,
  cursor: 'pointer',
};

const templateAdvancedTooltipStyle: CSSProperties = {
  background: '#023B50',
  minWidth: 160,
  borderRadius: '7px',
  zIndex: '5',
  padding: '8px',
};

const templateTooltipStyle: CSSProperties = {
  background: '#023B50',
  color: '#ffff',
  maxWidth: 220,
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  zIndex: '5',
};

export const MightyFuSubProduct: React.FC<{
  subProduct: ProductData;
  tooltipLoadCallback?: (arr: string[]) => Promise<IProductResponse[]>;
  tooltipOpenEventHandler?: () => void;
}> = ({ subProduct, tooltipLoadCallback, tooltipOpenEventHandler }) => {
  return (
    <StyledMightyFuSubProduct className="sub-product">
      <Box className="product-info" gap={'2px'}>
        {subProduct.images.product && (
          <div className={'product-img'}>
            <img src={subProduct.images.product} alt="product" />
          </div>
        )}
        {subProduct.quantityDisplay && (
          <StyledQuantity title={subProduct.quantityDisplay}>
            <div className={'quantity_text'}>{subProduct.quantityDisplay}</div>
          </StyledQuantity>
        )}
      </Box>
      <TooltipRenderer
        product={subProduct}
        tooltipLoadCallback={tooltipLoadCallback}
        tooltipOpenEventHandler={tooltipOpenEventHandler}
        advancedTooltipStyle={templateAdvancedTooltipStyle}
        simpleTooltipStyle={templateTooltipStyle}
        buttonStyle={tooltipButtonStyle}
      >
        <img
          className={'tooltip-icon'}
          src={tooltipIcon}
          alt={'tooltip-icon'}
        />
      </TooltipRenderer>
    </StyledMightyFuSubProduct>
  );
};
